import { render } from "./Vnud-Taxas.vue?vue&type=template&id=f10ca85c&scoped=true"
import script from "./Vnud-Taxas.vue?vue&type=script&lang=js"
export * from "./Vnud-Taxas.vue?vue&type=script&lang=js"

import "./Vnud-Taxas.vue?vue&type=style&index=0&id=f10ca85c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10ca85c"]])

export default __exports__